import { NavLink, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { NAV_HOME_SCENARIO_ITEMS } from '../../constants/navItems';
import { Icon } from '../header/draft/Icon';

type HomeScenarioSubNavProps = {
  variant: 'sidebar' | 'drawer';
  onNavigate?: () => void;
};

function isScenarioItemActive(pathname: string, matchPrefix?: string): boolean {
  if (!matchPrefix) return false;
  return pathname === matchPrefix || pathname.startsWith(`${matchPrefix}/`);
}

export function HomeScenarioSubNav({ variant, onNavigate }: HomeScenarioSubNavProps) {
  const { t } = useTranslation();
  const { pathname } = useLocation();
  const isSidebar = variant === 'sidebar';

  return (
    <div
      className={
        isSidebar
          ? 'soundpill-draft-sidebar__sub-group'
          : 'soundpill-mobile-nav-drawer__sub-group flex flex-col gap-0.5 ml-4 pl-3 mb-1'
      }
      role="group"
      aria-label={t('homepage.scenarioCustomSoundPill')}
    >
      {NAV_HOME_SCENARIO_ITEMS.map((item) => {
        const active = isScenarioItemActive(pathname, item.matchPrefix);
        return (
          <NavLink
            key={item.to}
            to={item.to}
            onClick={onNavigate}
            title={isSidebar ? t(item.labelKey) : undefined}
            className={
              isSidebar
                ? `soundpill-draft-sidebar__sub-item${active ? ' soundpill-draft-sidebar__sub-item--active' : ''}`
                : `soundpill-mobile-nav-drawer__sub-link flex items-center gap-3 px-3 py-2.5 rounded-lg font-headline text-sm no-underline ${
                    active
                      ? 'soundpill-mobile-nav-drawer__sub-link--active text-primary font-semibold bg-primary/10'
                      : 'text-on-surface-variant/90 font-medium hover:bg-white/5 hover:text-white'
                  }`
            }
          >
            <Icon
              name={item.icon}
              className={isSidebar ? 'soundpill-draft-sidebar__sub-item__symbol' : `text-lg ${active ? 'text-primary' : ''}`}
              filled={active}
            />
            <span className={isSidebar ? 'soundpill-draft-sidebar__sub-item__label' : active ? 'text-primary' : ''}>
              {t(item.labelKey)}
            </span>
          </NavLink>
        );
      })}
    </div>
  );
}
